import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { BrandingService } from '../../../../core/services/branding.service';
import { AuthService } from '../../../../core/services';
import {map, take} from 'rxjs/operators';

@Component({
    selector: 'app-freeway-layout-footer',
    templateUrl: './freeway-layout-footer.component.html',
    standalone: false
})
export class FreewayLayoutFooterComponent implements OnInit {
  footerLogo$: Observable<string> = this.brandingService.footerLogo$;
  footerLogoUrl;
  footerSecondLogo$: Observable<string> = this.brandingService.footerSecondLogo$;
  footerSecondLogoUrl;
  headerLogo$: Observable<string> = this.brandingService.headerLogo$;
  headerLogoUrl;
  headerSecondLogo$: Observable<string> = this.brandingService.headerSecondLogo$;
  headerSecondLogoUrl;
  footerCopyrightHtml$ = this.brandingService.footerCopyrightHtml$;
  socialLinks$ = this.brandingService.socialLinks$;
  isFooterAffiliate$ = this.brandingService.isFooterAffiliate$;

  isUserLogin$: Observable<boolean>;
  isContactUsPage$: Observable<boolean>;

  constructor(private brandingService: BrandingService,
              private authService: AuthService) {}

  ngOnInit() {
    this.isUserLogin$ = this.authService.isAuthenticated$;
    this.isContactUsPage$ = this.brandingService.getPageByTitle('contact_us').pipe(
      map(res => !!res)
    );

    this.footerLogo$.pipe(
      take(1)
    ).subscribe(footerUrl => {
      this.footerLogoUrl = footerUrl;
    });

    this.footerSecondLogo$.pipe(
      take(1)
    ).subscribe(footerUrl => {
      this.footerSecondLogoUrl = footerUrl;
    });

    this.headerLogo$.pipe(
      take(1)
    ).subscribe(headerUrl => {
      this.headerLogoUrl = headerUrl;
    });

    this.headerSecondLogo$.pipe(
      take(1)
    ).subscribe(headerUrl => {
      this.headerSecondLogoUrl = headerUrl;
    });
  }

  get isFooterLogo() {
    return false;
  }

  get isSecondFooterLogo() {
    return this.footerLogoUrl && this.footerSecondLogoUrl;
  }

  get isSecondHeaderLogo() {
    return this.headerLogoUrl && this.headerSecondLogoUrl;
  }
}
